export type OperationTransportMode =
  | 'drop'
  | 'send'
  | 'queue';

export function resolveOperationTransportMode(options: {
  hasManager: boolean;
  isConnected: boolean;
}): OperationTransportMode {
  if (!options.hasManager) {
    return 'drop';
  }

  return options.isConnected ? 'send' : 'queue';
}
